const BASE_API =  process.env.MIX_ENDLESS_API_URL

const state = {
	getAnOffer: {}
}
const getters = {
	getAnOfferGetter:({getAnOffer}) => getAnOffer
}
const mutations = {
	setGetAnOffer : (state,payload)=> {
		state.getAnOffer = payload
	},
}
const actions = {
	async createGetAnOffer({commit}, payload){
		await this.$axios.post(`${BASE_API}/create-multiple-quote`,payload.data,{headers:{...payload.headers}}).then(res => {
			commit('setGetAnOffer', res.data.result)
		})
	},
}

export default {namespaced:true,state,getters,mutations,actions}
